import { IconButton, Stack, Typography } from "@mui/material";
import { T } from "components/util/t";
import { TeamMembersList } from "../dialogs/team/TeamMembersList";
import { AthleteSelectorField } from "../forms/fields/SelectorField";
import { Card } from "../cards/Card";
import { Delete } from "@mui/icons-material";
import { createTeamEntry } from "./SelectDivisionDialog";
import { getTeamName } from "./TeamRegistrationForm";

export const TeamRegistrationTeamCard = ({ entry, division, eventTeam, options, athletes, registering, registered, formAthletes, updateAthlete, removeAthlete }) => {
    const index = formAthletes.findIndex(formAthlete => formAthlete.name === entry.name);

    const onSelect = order => ({ label, value }) => updateAthlete(index, { ...entry, team_members: [...entry.team_members, typeof value === "string" ? { name: value, order } : { athlete_id: value, name: label, order }] });
    const onRemove = order => () => updateAthlete(index, { ...entry, team_members: entry.team_members.filter(member => member.order !== order) });

    const removeTeam = () => {
        formAthletes.forEach((entry, i) => i > index && entry.team_members && entry.registrations_attributes.some(registration => registration.option_id === division.optionId) && updateAthlete(i, { ...entry, name: createTeamEntry(eventTeam, registered, registering.slice(0, -2), division).name }));
        removeAthlete(index);
    };

    const onUpdateTeamMemberRole = order => role => {};

    return (
        <Card marginBottom={1}>
            <Stack direction="row" justifyContent="space-between">
                <Typography variant="label1">{registering.length > 1 || registered.length ? getTeamName(entry.name, eventTeam) : <T>Team roster</T>}</Typography>
                {registering.length > 1 && <IconButton size="small" onClick={removeTeam}><Delete/></IconButton>}
            </Stack>
            <TeamMembersList
                teamConfig={division.teamConfig}
                members={entry.team_members.reduce((members, member) => ({ ...members, [member.order]: { athlete: member } }), {})}
                onAthleteRemoved={onRemove}
                onUpdateTeamMemberRole={onUpdateTeamMemberRole}
                renderTeamMembersSelector={order => <AthleteSelectorField options={options} onChange={onSelect(order)} />}
                athletesHeading="Athletes (required)"
                teamRoles={[]}
            />
        </Card>
    );
};
